module.exports = __webpack_public_path__ + "img/117.c271b6be.jpg";